const productMainSection = $('#hero-section');
const firstMediaGroup = productMainSection.find('#media-group-0');
const productsMedia = firstMediaGroup.find('.media-item');
const productMainMenuParent = productMainSection.find('.product-main-menu-parent');
const productMainMenuParentInner = productMainMenuParent.find('.offset-element');
const productMainNavItems = productMainSection.find('.product-main-nav-item');
const modelParent = productMainSection.find('.product-model-parent');
const productMainBtn = productMainSection.find('.button-parent');
const productInEase = CustomEase.create('productInEase', '0.2, 0.0, 0.2, 1.0');
const embla = productMainSection.find('.embla');
const emblaViewport = embla.find('.embla__viewport');
const emblaControlsNode = embla.find('.embla__controls')
const emblaDotsNode = embla.find('.embla__dots');

const cartNotificationOverflow = $('.cart-notification-overflow');
const cartNotificationMenu = $('.cart-notification');
const cartNotificationCloseBtn = cartNotificationOverflow.find('.cart-notification-close');
const cartNotificationProduct = cartNotificationOverflow.find('.cart-notification-product-name');
const cartNotificationImage = cartNotificationOverflow.find('.cart-notification-image');

const [nav] = performance.getEntriesByType('navigation');

const publishLinkedInAddToCart = (productData, quantity) => {
  if (!productData.length) return;

  const variantId = productData.attr('data-variant-id') || productData.attr('data-product-id');
  const productId = productData.attr('data-shopify-product-id') || variantId;
  const priceInCents = Number(productData.attr('data-product-price'));
  const payload = {
    productId,
    variantId,
    quantity,
    currency: productData.attr('data-currency'),
  };

  if (!Number.isNaN(priceInCents)) {
    payload.price = priceInCents / 100;
  }

  window.publishActivforceAnalyticsEvent?.('activforce:linkedin_add_to_cart', payload);
};

let productEmblaApi = undefined;
let productInTL = gsap.timeline({
  paused: true,
  onComplete: () => {
    productMainSection.css('overflow-x', 'unset');
    $('.gradient-background').css('display', 'block');
    productMainMenuParent.css('top', '2.5vw');
    addBtnHover(productMainBtn);
    lenis.start();
    $(window).trigger('heroReady');
    if (isDesktop() || isTablet()) {
      productEmblaApi.plugins().autoplay?.play();
    }
  },
});

const cartNotificationAnimation = () => {
  const cartNotificationOverflowWidth = pxToVw(cartNotificationOverflow.outerWidth());
  const cartNotificationOverflowHeight = pxToVw(cartNotificationOverflow.outerHeight());

  const cartNotificationTL = gsap.timeline({
    paused: true,
    onStart: () => {
      isCartNotificationOpened = true;
    },
    onComplete: () => {
      gsap.delayedCall(2, () => {
        if (isCartNotificationOpened) {
          cartNotificationTL.reverse();
        }
      });
    },
  });
  cartNotificationTL.add(
    gsap.fromTo(
      cartNotificationOverflow,
      {
        y: isDesktop() ? '-1.25vw' : 0,
        x: `-${(cartNotificationOverflowWidth - 6.25) / 2}vw`,
        width: isDesktop() ? '6.25vw' : 0,
        height: '0vw',
      },
      {
        y: 0,
        x: 0,
        width: `${cartNotificationOverflowWidth}vw`,
        height: `${cartNotificationOverflowHeight}vw`,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  cartNotificationTL.add(
    gsap.fromTo(
      cartNotificationCloseBtn,
      {
        x: `-5.313vw`,
        rotate: 0,
      },
      {
        x: 0,
        rotate: 180,
        duration: 1,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  cartNotificationTL.add(
    gsap.fromTo(
      cartNotificationMenu,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.33,
        ease: 'opacityInEasing',
      }
    ),
    0.33
  );

  return cartNotificationTL;
};

cartNotificationTL = cartNotificationAnimation();

const addToCartControl = () => {
  const addToCartBtn = $('.product-add-cart-parent, .float-menu-parent').find('.button-parent');
  const quantityInputs = $('.quantity-input');
  const quantityChangerBtns = $('.quantity-changer');

  let currentQuantity = 1;

  function changeInputsValue() {
    quantityInputs.each(function () {
      $(this).val(currentQuantity);
    });
  }

  quantityChangerBtns.on('click', function () {
    const diff = $(this).attr('id') == 'quantity-plus' ? 1 : -1;
    if (currentQuantity + diff >= 1) {
      currentQuantity += diff;
    }
    changeInputsValue();
  });

  quantityInputs.on('input', function () {
    currentQuantity = Number($(this).val());
    if (currentQuantity == 0) {
      currentQuantity = 1;
    }
    changeInputsValue();
  });

  addToCartBtn.on('click', function () {
    const clickedAddToCartBtn = $(this);
    if((clickedAddToCartBtn.attr('href') || '').includes('javascript:void(0)')){
      const productData = clickedAddToCartBtn.closest('.product-add-cart-parent, .float-menu-parent').find('.product-id').first();
      const productID = productData.attr('data-product-id');
      const productTitle = productData.attr('data-product-title');
      const productPrice = productData.attr('data-product-price');
      const productImage = productData.attr('data-product-image');
      const addedQuantity = currentQuantity;
      let savedCart = localStorage.getItem('cart');
      savedCart = savedCart ? JSON.parse(savedCart) : [];
      const existingProduct = savedCart.find((item) => item.productID === productID);

      if (existingProduct) {
        existingProduct.productQuantity += currentQuantity;
      } else {
        savedCart.push({
          productID: productID,
          productTitle: productTitle,
          productPrice: productPrice,
          productImage: productImage,
          productQuantity: currentQuantity,
        });
      }
      localStorage.setItem('cart', JSON.stringify(savedCart));
      publishLinkedInAddToCart(productData, addedQuantity);
      currentQuantity = 1;
      changeInputsValue();
      renderCart();
      cartNotificationImage.attr('src', productImage);
      cartNotificationProduct.text(productTitle);
      if (!isCartOpened) {
        cartTL.play();
        //cartNotificationTL.play();
      }
    }
  });

  cartNotificationCloseBtn.on('click', function () {
    cartNotificationTL.reverse();
    isCartNotificationOpened = false;
  });
};

const animateMenuIn = () => {
  const menuInTL = gsap.timeline({ paused: true });
  menuInTL.add(
    gsap.to(productMainMenuParentInner.slice(0, 4), {
      x: 0,
      y: 0,
      duration: 1,
      ease: 'pageInEasing',
    }),
    2.48
  );
  menuInTL.add(
    gsap.to(productMainMenuParentInner.slice(0, 4), {
      opacity: 1,
      duration: 0.67,
      ease: 'opacityInEasing',
    }),
    2.81
  );
  menuInTL.add(
    gsap.to(productMainMenuParentInner.slice(4), {
      x: 0,
      y: 0,
      duration: 1,
      ease: 'pageInEasing',
      stagger: {
        each: 0.16,
      },
    }),
    2.64
  );
  menuInTL.add(
    gsap.to(productMainMenuParentInner.slice(4), {
      opacity: 1,
      duration: 0.67,
      ease: 'opacityInEasing',
      stagger: {
        each: 0.16,
      },
    }),
    2.97
  );

  return menuInTL;
};

const productMainInAnimation = () => {
    lenis.stop();
    headerAnimation(false, 0, 0).play();
    productInTL.add(gsap.fromTo([productsMedia, productMainMenuParentInner], {
      y: firstMediaGroup.outerHeight(),
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: 1.1,
      ease: 'pageInEasing',
      stagger: 0.083,
    }), 0.4);
    productInTL.add(gsap.fromTo(emblaControlsNode, {
      y: firstMediaGroup.outerHeight(),
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: 1.1,
      ease: 'pageInEasing',
    }), 0.6);
    
    productInTL.add(headerAnimation(true, 0.6, 0.01).play(), 1.5);
};

const MODEL_VIEWER_SCRIPT_URL = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';

const addProductModel = () => {
  const modelViewer = productMainSection.find('model-viewer');
  const modelViewerControls = $('.attachment-control-card');

  addModelViewer(modelAttachments, modelViewer, modelViewerControls)
    .then((scene) => {
      scene.model.rotation.set(-Math.PI / 18, Math.PI / 8, -Math.PI * 1.2);
      let isModelDragging = false;
      modelViewer.on('pointerdown mousedown touchstart', function (e) {
        productEmblaApi?.plugins()?.autoplay?.stop();
        e.stopPropagation();
      });

      modelViewer.on('pointermove mousemove touchmove', function (e) {
        productEmblaApi?.plugins()?.autoplay?.stop();
        e.stopPropagation();
      });

      modelViewer.on('pointerup mouseup touchend pointercancel', function (e) {
        productEmblaApi?.plugins()?.autoplay?.stop();
        e.stopPropagation();
      });

      $(document).on('pointerup pointercancel', function () {
        if (!isModelDragging) return;
        isModelDragging = false;
        productEmblaApi?.plugins()?.autoplay?.start();
      });
    })
    .catch((err) => {
      console.error('Model download error', err);
    });
};

const addProductMainEmbla = () => {
    if (!window.EmblaCarousel || !emblaViewport.length) {
      return;
    }

    const OPTIONS = (isDesktop() || isTablet()) ? { align: 'start', loop: true } : { align: 'start', dragFree: true };
    //const plugins = [EmblaCarouselAutoScroll({ speed: 1, stopOnMouseEnter: true, stopOnInteraction: false })];
    const plugins =
      (isDesktop() || isTablet()) && window.EmblaCarouselAutoplay
        ? [EmblaCarouselAutoplay({ delay: 4000, stopOnMouseEnter: true, stopOnInteraction: false })]
        : [];
    productEmblaApi = EmblaCarousel(emblaViewport.get(0), OPTIONS, plugins);
    if(isDesktop() || isTablet()){
      addDotButtonAndClickHandlers(productEmblaApi, emblaDotsNode.get(0), toggleDotsAnimation)
      addAutoplayProgressListeners(productEmblaApi, emblaDotsNode.get(0), 'x');
      productEmblaApi.plugins().autoplay?.stop();
    }
}

/** Load ModelViewer script only when this product has a 3D model; after idle to avoid blocking initial paint. */
function loadModelViewerThenInit() {
  const modelViewer = productMainSection.find('model-viewer');
  if (!modelViewer.length) return;
  if (window.customElements.get('model-viewer')) {
    addProductModel();
    return;
  }
  const script = document.createElement('script');
  script.type = 'module';
  script.src = MODEL_VIEWER_SCRIPT_URL;
  script.onload = () => {
    window.customElements.whenDefined('model-viewer').then(() => addProductModel());
  };
  document.head.appendChild(script);
}

addToCartControl();
productMainInAnimation();

if (isDesktop() || isTablet()) {
  if (productMainSection.find('model-viewer').length) {
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(() => loadModelViewerThenInit(), { timeout: 2500 });
    } else {
      setTimeout(loadModelViewerThenInit, 1);
    }
  }
  addProductMainEmbla();
} else {
  modelParent.remove();
}

$(window).on('load', function () {
  $('.gradient-background').css('display', 'none');
  gsap.set($('body'), { opacity: 1 });
  const [nav] = performance.getEntriesByType('navigation');
  pageIn(productInTL, nav, 0, true);
});

productMainSection.ready(() => {
  if (isDesktop()) {
    productMainNavItems.each(function () {
      const navIcon = $(this).find('.nav-item-logo');
      $(this).on('mouseenter', () => arrowAnimation(navIcon, 1, 1));
      $(this).on('mouseleave', () => arrowAnimation(navIcon, 1, 0));
    });
  }
})
